<template>

</template>

<script>
export default {
  name: "QARDetalhesOperacao"
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARDetalhesOperacao.vue